{
  "screen": {
    "overline": "НАШИ НАСТАВНИКИ",
    "title": "Познакомьтесь с",
    "titleHighlight": "Мастерами",
    "subtitle": "Опытные практики, посвятившие себя вашему пути роста и самопознания.",
    "searchPlaceholder": "Поиск по имени или практике...",
    "loading": "Загрузка экспертов...",
    "retryConnection": "ПОВТОРИТЬ ПОДКЛЮЧЕНИЕ",
    "noResults": "Ничего не найдено",
    "comingSoon": "Скоро",
    "noResultsHint": "Попробуйте другое ключевое слово.",
    "comingSoonHint": "Мы подключаем новых мастеров.",
    "viewJourney": "ПОДРОБНЕЕ"
  },
  "specialties": {
    "all": "Все",
    "yogaMovement": "Йога и движение",
    "meditation": "Медитация",
    "buddhism": "Буддизм",
    "shaivism": "Шайвизм",
    "psychology": "Психология",
    "wellness": "Велнес",
    "breathwork": "Дыхание"
  },
  "detail": {
    "allMasters": "ВСЕ МАСТЕРА",
    "masterProfile": "ПРОФИЛЬ МАСТЕРА",
    "defaultTagline": "Йога и медитация · Дыхание · Осознанность",
    "overview": "Обзор",
    "content": "Контент",
    "community": "Сообщество",
    "events": "События",
    "all": "Все",
    "upcomingLives": "Предстоящие Live-сессии",
    "pastLives": "Прошлые Live-сессии",
    "videoPractices": "Видеопрактики",
    "noContentAll": "Контент пока недоступен.",
    "noContentUpcoming": "Нет запланированных Live-сессий.",
    "noContentPast": "Нет прошлых записей.",
    "noContentVideos": "Видеопрактики пока не опубликованы.",
    "recording": "ЗАПИСЬ",
    "video": "ВИДЕО",
    "practice": "Практика",
    "messageMaster": "Написать мастеру",
    "messageIntro": "Здравствуйте! Хотелось бы узнать подробнее о {{title}}...",
    "about": "О мастере",
    "masterBio": "Биография",
    "manifesto": "Манифест",
    "upcomingSessions": "Ближайшие сессии",
    "liveStreamsByMaster": "Live-сессии и события от {{name}}",
    "noUpcomingSessions": "Нет ближайших сессий.",
    "viewAllSessions": "ВСЕ СЕССИИ",
    "couldntLoadContent": "Не удалось загрузить контент.",
    "upcomingEvents": "Предстоящие события",
    "retreatsAndGatherings": "Ретриты, воркшопы и встречи от {{name}}",
    "noUpcomingEvents": "Нет предстоящих событий.",
    "getNotified": "Получайте уведомления о сессиях {{name}}",
    "defaultBio": "Практик, посвятивший себя пути внутреннего роста и осознанной жизни.",
    "masterNotFound": "Мастер не найден",
    "welcomeTo": "Добро пожаловать к {{name}}",
    "followers": "Подписчики",
    "videos": "Видео",
    "lives": "Live-сессии",
    "pushOn": "Уведомления включены",
    "pushOff": "Уведомления отключены",
    "addToCal": "В календарь",
    "aboutThisEvent": "О СОБЫТИИ",
    "contact": "КОНТАКТ",
    "filled": "занято",
    "register": "ЗАПИСАТЬСЯ",
    "message": "НАПИСАТЬ",
    "messageSent": "Сообщение отправлено.",
    "messageDelivered": "Ваше сообщение доставлено {{name}}. Ответ придёт в ближайшее время.",
    "yourName": "ВАШЕ ИМЯ *",
    "enterYourName": "Введите ваше имя",
    "yourEmail": "ВАШ EMAIL",
    "emailPlaceholder": "ваш@email.com",
    "messageFieldLabel": "СООБЩЕНИЕ *",
    "sendMessage": "ОТПРАВИТЬ",
    "orEmailDirectly": "Или напишите на email:",
    "fillNameAndMessage": "Пожалуйста, заполните имя и сообщение",
    "spotsLeft": "{{left}} / {{total}} мест осталось",
    "unlimitedSpots": "Без ограничений",
    "follow": "ПОДПИСАТЬСЯ",
    "following": "ПОДПИСАН",
    "subscribe": "ПОДПИСАТЬСЯ",
    "retry": "ПОВТОРИТЬ",
    "online": "ОНЛАЙН",
    "offline": "ОФЛАЙН",
    "live": "ЭФИР",
    "about_": "О:",
    "questionAbout": "Вопрос о: {{title}}"
  },
  "eventTypes": {
    "retreat": "РЕТРИТ",
    "workshop": "ВОРКШОП",
    "ceremony": "ЦЕРЕМОНИЯ",
    "class": "ЗАНЯТИЕ",
    "festival": "ФЕСТИВАЛЬ"
  },
  "calendar": {
    "mon": "ПН",
    "tue": "ВТ",
    "wed": "СР",
    "thu": "ЧТ",
    "fri": "ПТ",
    "sat": "СБ",
    "sun": "ВС",
    "todaysSchedule": "Календарь на сегодня",
    "noEventsThisDay": "Нет событий в этот день"
  },
  "categories": {
    "mindfulness": "Осознанность",
    "yoga": "Йога",
    "breathwork": "Дыхание",
    "meditation": "Медитация"
  },
  "native": {
    "title": "Мастера",
    "subtitle": "Находите мастеров и людей,\nс которыми резонирует ваш путь.",
    "empty": "Никого не нашлось",
    "searchA11y": "Поиск",
    "filtersA11y": "Фильтры",
    "mySubscriptions": "Мои подписки",
    "all": "Все",
    "followersCount_one": "{{count}} подписчик",
    "followersCount_few": "{{count}} подписчика",
    "followersCount_many": "{{count}} подписчиков",
    "followersCount_other": "{{count}} подписчиков"
  }
}
